export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/nationalId.c09440f9.svg","height":16,"width":13,"blurWidth":0,"blurHeight":0};